import { CxFeatureFlags, cxFeatureFlagsSchema } from "@metriport/shared-internal";
import { getOssProxyOrFail } from "./api";

const FEATURE_FLAGS_URL = `/medical/v1/feature-flags`;

export async function getDashboardFeatureFlagsForUser(): Promise<CxFeatureFlags> {
  const apiOssProxy = getOssProxyOrFail();
  try {
    const resp = await apiOssProxy.get(FEATURE_FLAGS_URL);
    return cxFeatureFlagsSchema.parse(resp.data);
  } catch (error) {
    return {};
  }
}
